export const SoundPressure = () => (
  <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter
        x="-37.6%"
        y="-37.6%"
        width="175.2%"
        height="175.2%"
        filterUnits="objectBoundingBox"
        id="ii3f7dq3ya"
      >
        <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <g
      transform="translate(9.44 9.931)"
      filter="url(#ii3f7dq3ya)"
      stroke="#FFF"
      strokeWidth="2.162"
      fill="none"
      fillRule="evenodd"
    >
      <circle cx="15.403" cy="15.403" r="15.403" />
      <circle cx="13.936" cy="16.504" r="12.469" />
      <circle cx="11.002" cy="19.438" r="7.335" />
      <circle cx="12.103" cy="18.337" r="10.269" />
    </g>
  </svg>
);
